(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('VisioneConsensoDeleteController',VisioneConsensoDeleteController);

    VisioneConsensoDeleteController.$inject = ['$uibModalInstance', 'entity', 'VisioneConsenso'];

    function VisioneConsensoDeleteController($uibModalInstance, entity, VisioneConsenso) {
        var vm = this;

        vm.visioneConsenso = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VisioneConsenso.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
